import { Table } from '@mantine/core';
import { useState } from 'react';
import { KeyedRow } from '../../../components/KeyedRow';
import {
	formatToCurrency,
	formatToDateStringOrDefault,
	formatToTimeStringOrDefault,
} from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { ProductLogDto } from '../types/ProductLogDto';

interface ProductRowProps {
	originalProduct: ProductLogDto;
}

export function ProductLogRow({ originalProduct }: ProductRowProps) {
	const [productOpen, setProductOpen] = useState(false);
	const [product, setProduct] = useState(originalProduct);
	return (
		<>
			<KeyedRow>
				<Table.Td>{formatToDateStringOrDefault(product.dateTime)}</Table.Td>
				<Table.Td>{formatToTimeStringOrDefault(product.dateTime)}</Table.Td>
				<Table.Td>{undefinedCheck(product.operator)}</Table.Td>
				<Table.Td>{undefinedCheck(product.skuId)}</Table.Td>
				<Table.Td>{undefinedCheck(product.description)}</Table.Td>
				<Table.Td>{undefinedCheck(product.till)}</Table.Td>
				<Table.Td>{undefinedCheck(product.branch)}</Table.Td>
				<Table.Td>{formatToCurrency(product.price)}</Table.Td>
				<Table.Td>{formatToCurrency(product.caseQty)}</Table.Td>
				<Table.Td>{product.stockQty}</Table.Td>
				<Table.Td>{product.stockQtyAdded}</Table.Td>
				<Table.Td>{product.logType}</Table.Td>
			</KeyedRow>
		</>
	);
}
